import { createScope, molecule } from 'bunshi'
import { atom } from 'jotai'

export const editDiffButtonScope = createScope(Symbol())

export const isVisibleDialogMolecule = molecule((_mol, scope) => {
  scope(editDiffButtonScope)

  return atom(false)
})
